{
  "valid": "Valabil"
}
